import { marker as i18n } from '@biesbjerg/ngx-translate-extract-marker';

import type { IHeader } from 'src/shared/types/header';

import type { IRebrandedSecondaryNavData } from './types';
import type { IMenuItem } from '../../entities/types';

export const getHeaderRebrandedSecondaryNavData: (translateFn, loginPageLink: string) => IRebrandedSecondaryNavData = (
    translateFn,
    loginPageLink: string
): IRebrandedSecondaryNavData => ({
    contactSales: {
        title: i18n('Contact Sales'),
        key: 'contact-sales',
        url: '/contact-sales/',
        locales: [
            'de',
            'en',
            'es',
            'fr',
            'it',
            'ja',
            'pt-br',
            'ru',
            'da',
            'id',
            'ms',
            'nl',
            'no',
            'pl',
            'sv',
            'ko',
            'zh-cn',
            'zh-tw',
        ],
    },
    login: {
        title: i18n('Log in'),
        key: 'login',
        url: loginPageLink,
    },
    trialFormStrings: {
        buttonSendText: i18n('Start for free'),
        inputLabelText: i18n('Business email'),
        inputPlaceholderText: 'name@company.com',
        googleButtonText: {
            business: i18n('or use Google business account'),
            nonBusiness: i18n('or use Google account'),
        },
    },
    mobileButtonSendText: i18n('Get started'),
    popupTitle: i18n('Start free trial'),
    popupSubtitle: i18n('Free 14-day trial. No credit card required. Cancel&nbsp;anytime.'),
    bookDemo: {
        title: i18n('Request a demo'),
        titleMobile: i18n('Contact us'),
        key: 'book-demo',
        url: '/solutions-talk-to-sales-team/',
        locales: ['fr'],
        localeLinks: {
            fr: '/contacter-lequipe-commerciale/',
        },
    },
});

export const transformHeaderData: (data: IMenuItem[]) => IHeader = (data): IHeader => {
    // TODO: add also  secondary navigation, currently it only works for main one

    const transformedData = {
        headerMenu: {
            secondaryNavigation: [], // ILocalizableLink
            mainNavigation: [],
        },
        trialForm: {
            inputPlaceholder: '',
            buttonText: '',
            validationErrorEmail: '',
        },
        loginButton: {
            text: '',
        },
    };

    const mainNav = !Array.isArray(data)
        ? []
        : data
              .map((item) => {
                  const promos = item.promos ?? [];

                  return {
                      key: item.code,
                      url: item.url,
                      title: item.title,
                      layout_type: item.layout_type,
                      promo: promos.length ? promos[0] : [],
                      promos,
                      cta_list: item.menu_item_bottom_cta || [],
                      submenu: ((menu) => {
                          if (menu.find((subitem) => subitem.items[0])) {
                              return menu;
                          } else if (menu.length === 0) {
                              return [];
                          } else {
                              return [{ items: menu }];
                          }
                      })(
                          item.children.map((subitem) => ({
                              title: subitem.title,
                              key: subitem.code,
                              url: subitem.url,
                              description: subitem.description,
                              is_highlighted: subitem.is_highlighted,
                              image: subitem.image,
                              animatedIconCode: subitem.animatedIconCode,
                              label: subitem.label,

                              items: subitem.children.map((child) => ({
                                  key: child.code,
                                  title: child.title,
                                  url: child.url,
                                  description: child.description,
                                  is_highlighted: child.is_highlighted,
                                  image: child.image,
                                  animatedIconCode: child.animatedIconCode,
                                  label: child.label,
                              })),
                          }))
                      ),
                  };
              })
              .map((item) => {
                  if (item.submenu.length === 0) {
                      delete item.submenu;
                  }
                  return item;
              });

    transformedData.headerMenu.mainNavigation = mainNav;

    return transformedData;
};
